import * as Yup from 'yup';

export const ConfirmSubscriptionFormRecordSchema = Yup.object()
                                                      .shape({
                                                                 'price': Yup.string()
                                                                             .nullable(),
                                                                 'quantity': Yup.number()
                                                                                .required('quantity is required field')
                                                                                .min(1, 'quantity must be at least 1'),
                                                             });